import React, { useEffect, useRef } from 'react'
import { Button } from 'components/Button/Button'
import { useTranslation } from 'react-i18next'
import { TimeoutMessage } from 'components/TimeoutMessage/TimeoutMessage'
import { buildAbsoluteMedicareMyUrl } from 'utils/urls/buildAbsoluteMedicareMyUrl'
import { Component } from '@cms-max/medicare-api-sdk'

export interface Step0Props {
  handleOnSubmit: () => void
  showTimeoutMessage: boolean
  setShowTimeoutMessage: (showTimeoutMessage: boolean) => void
}

export const Step0: React.FC<Step0Props> = (
  { handleOnSubmit, showTimeoutMessage, setShowTimeoutMessage }
) => {
  const onSubmit = (event: any) => {
    event.preventDefault()
    handleOnSubmit()
  }
  const { t } = useTranslation('mcfStep0Page')
  const ref = useRef<HTMLAnchorElement | HTMLButtonElement>(null)

  useEffect(() => {
    return () => {
      setShowTimeoutMessage(false)
    }
  }, [setShowTimeoutMessage])

  return (
    <form data-testid='form-step0' onSubmit={onSubmit}>
      <h1 className='ds-text-heading--3xl my-u-mb--20' id='maincontent' tabIndex={-1}>{t('Medicare Complaint Form')}</h1>
      {showTimeoutMessage && <TimeoutMessage />}
      <p>{t('Complete this form to file a complaint about your Medicare Health or drug plan')}</p>
      <div className='ds-c-alert ds-c-alert--hide-icon my-u-my--20'>
        <div className='ds-c-alert__body'>
          <h2 className='ds-text-heading--2xl ds-c-alert__heading ds-u-margin-bottom--3 ds-u-leading--base'>{t('Do you need help with your complaint within 10 days?')}</h2>
          <p className='ds-c-alert__text'>
            {t('alert.p1')}
          </p>
          <p className='ds-c-alert__text my-u-mt--5'>
            {t('alert.p2')}
          </p>
        </div>
      </div>
      <Button
        ref={ref}
        className='ds-c-button ds-c-button--solid ds-c-button--big my-u-font-size--18'
        data-testid='step0-next'
        type='submit'
        siteActivityProps={{
          component: Component.Mcf,
          clickData: {
            linkText: 'File a Complaint',
            linkUrl: buildAbsoluteMedicareMyUrl('/medicare-complaint/step1')
          }
        }}
      >
        {t('File a Complaint')}
      </Button>
    </form>
  )
}
